import React from 'react'
import WatchTableItem from './WatchTableItem';
import WatchTopSearch from './WatchTopSearch';

const MyWatchlist = () => {
  return (
    <div className="_creator_top_wrap">
    <div className="container">
        <div className="row align-items-center">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div className="_stats_title_wrap">
                    <h2 className="_creator_title">My Watchlist</h2>
                </div>
            </div>
        </div>
        <div className="_stats_main_wrapper">
            <div className="row">
                <WatchTopSearch/>
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <div className="_fav_table_item_header">
                        <ul className="_fav_table_item_header_main">
                            <li className="_fav_table_header_item">
                                <input type="checkbox" name="colcheck" id="colcheck" className="colcheck_input" />
                                <label for="colcheck" className="_fav_table_header_colcheck">Collections</label>
                            </li>
                            <li className="_fav_table_header_item">
                                Floor Price
                            </li>
                            <li className="_fav_table_header_item">
                                7d Volume
                            </li>
                            <li className="_fav_table_header_item">
                                24h %
                            </li>
                            <li className="_fav_table_header_item">
                                7d %
                            </li>
                            <li className="_fav_table_header_item">
                                Owners
                            </li>
                            <li className="_fav_table_header_item">
                                Item
                            </li>
                            <li className="_fav_table_header_item">
                                Action
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <div className="_nft_settings_main_bottom_body">
                        <div className="row my-3">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <WatchTableItem/>
                            </div>
                        </div>
                        <div className="row my-5">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <div className="_load_more_btn_wrap text-center">
                                    <button className="_stat_item_load_btn">
                                        Load More
                                    </button>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>


    </div>
</div>
  )
}

export default MyWatchlist;